<h1 class="text-dark text-xl" mat-dialog-title>Allega Polizza PDF</h1>
<div class="w-full" mat-dialog-content>
  <app-form-upload-insurance-file
    [data]="formData"
    [dialogRef]="dialogRef"
  ></app-form-upload-insurance-file>
</div>
